import { render, staticRenderFns } from "./NewsPullout.vue?vue&type=template&id=2561f727&scoped=true&"
import script from "./NewsPullout.vue?vue&type=script&lang=js&"
export * from "./NewsPullout.vue?vue&type=script&lang=js&"
import style0 from "./NewsPullout.vue?vue&type=style&index=0&id=2561f727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561f727",
  null
  
)

export default component.exports